class SectionScroll extends HTMLElement {
  constructor(){
    super();
    this.scrollToIndex = this.dataset.scrollToIndex;
    this.link = this.querySelector('.section-scroll-link');
    this.mainContentSections = document.querySelectorAll('#MainContent section');
  }

  connectedCallback() {
    this.handleLinkClick();
  }

  handleLinkClick() {
    this.link.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.scrollToIndex) {
        this.mainContentSections[this.scrollToIndex].scrollIntoView({ behavior: "smooth", block: "end" });
      }
    })
  }
}

customElements.define('section-scroll', SectionScroll);